module.exports = __webpack_public_path__ + "static/media/supercharger-lrg.22c68784.svg";